<ng-container *ngIf="client">
  <!-- anonymous patient -->
  <ng-container *ngIf="isAnonymous">
    <span class="badge badge-secondary">{{_(KEYS.RENDERER.ANONYMOUS)}}</span>
  </ng-container>

  <!-- pseudonymous patient -->
  <ng-container *ngIf="isPseudonymous">
    <a *ngIf="linkMode === 'route'"
       class="badge badge-secondary"
       [ngClass]="{'grid-link': canEdit}"
       [routerLink]="getRouterLink()">
      {{_(KEYS.RENDERER.PSEUDONYMOUS)}} {{pseudoIdText}}
    </a>
    <span *ngIf="linkMode === 'event'"
          class="badge badge-secondary"
          [ngClass]="{'grid-link': canEdit}"
          (click)="onBadgeClick()">
      {{_(KEYS.RENDERER.PSEUDONYMOUS)}} {{pseudoIdText}}
    </span>
  </ng-container>

  <!-- normal patient -->
  <ng-container *ngIf="!isAnonymous && !isPseudonymous">
    <!-- display field: linked badge -->
    <a *ngIf="linkMode === 'route'"
       class="badge badge-success"
       [ngClass]="{'grid-link': canEdit}"
       [routerLink]="getRouterLink()">
      <span *ngFor="let field of displayValues" class="display-field">
        <ng-container *ngIf="field.label">{{field.label}} </ng-container>{{field.value}}
      </span>
    </a>
    <span *ngIf="linkMode === 'event'"
          class="badge badge-success"
          [ngClass]="{'grid-link': canEdit}"
          (click)="onBadgeClick()">
      <span *ngFor="let field of displayValues" class="display-field">
        <ng-container *ngIf="field.label">{{field.label}} </ng-container>{{field.value}}
      </span>
    </span>

    <!-- detail line -->
    <div *ngIf="detailValues.length > 0" class="text-muted small mt-1">
      <ng-container *ngFor="let field of detailValues; let isLast = last">
        <ng-container *ngIf="field.label">{{field.label}} </ng-container>{{field.value}}<ng-container *ngIf="!isLast"> - </ng-container>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
